<div class="dashboard-container">
  <!-- Quick Access Grid Section -->
  <div class="quick-access-section" *ngIf="hasAnyQuickAccess()">
    <h2 class="section-title">Accesos Rápidos</h2>
    <div class="grid-container">
      <div class="cards-wrapper">
        <!-- Card for Procesos -->
        <div class="card-item" *ngIf="hasRoutePermission('procesos')">
          <div class="ms-PersonaCard">
            <div class="ms-PersonaCard-persona">
              <div class="ms-Persona ms-Persona--lg">
                <div class="ms-Persona-imageArea">
                  <i class="ms-Icon ms-Icon--ProcessMetaTask clickableIcon" (click)="navigateTo('/home/procesos')"></i>
                </div>
                <div class="ms-Persona-details">
                  <div class="ms-Persona-primaryText">Procesos</div>
                  <div class="ms-Persona-secondaryText">
                    Cree o gestione un proceso
                  </div>
                </div>
              </div>
            </div>
            <ul class="ms-PersonaCard-actions">
              <li
                data-action-id="chat"
                class="ms-PersonaCard-action is-active"
                tabindex="1"
              >
                <i class="ms-Icon ms-Icon--Processing"></i>
              </li>
              <li
                class="ms-PersonaCard-overflow"
                (click)="navigateTo('/home/procesos')"
              >
                Ir a Procesos
              </li>
              <li
                data-action-id="org"
                class="ms-PersonaCard-action ms-PersonaCard-orgChart"
                tabindex="5"
              >
                <i class="ms-Icon ms-Icon--Org"></i>
              </li>
            </ul>
          </div>
        </div>

        <!-- Card for Formularios -->
        <div class="card-item" *ngIf="hasRoutePermission('formularios')">
          <div class="ms-PersonaCard">
            <div class="ms-PersonaCard-persona">
              <div class="ms-Persona ms-Persona--lg">
                <div class="ms-Persona-imageArea">
                  <i class="ms-Icon ms-Icon--FormLibrary clickableIcon" (click)="navigateTo('/home/formularios')"></i>
                </div>
                <div class="ms-Persona-details">
                  <div class="ms-Persona-primaryText">Formularios</div>
                  <div class="ms-Persona-secondaryText">
                    Cree o gestione un formulario
                  </div>
                </div>
              </div>
            </div>
            <ul class="ms-PersonaCard-actions">
              <li
                data-action-id="chat"
                class="ms-PersonaCard-action is-active"
                tabindex="1"
              >
                <i class="ms-Icon ms-Icon--FormLibrary"></i>
              </li>
              <li
                class="ms-PersonaCard-overflow"
                (click)="navigateTo('/home/formularios')"
              >
                Ir a Formularios
              </li>
              <li
                data-action-id="org"
                class="ms-PersonaCard-action ms-PersonaCard-orgChart"
                tabindex="5"
              >
                <i class="ms-Icon ms-Icon--Org"></i>
              </li>
            </ul>
          </div>
        </div>

        <!-- Card for Usuarios -->
        <div class="card-item" *ngIf="hasRoutePermission('usuarios')">
          <div class="ms-PersonaCard">
            <div class="ms-PersonaCard-persona">
              <div class="ms-Persona ms-Persona--lg">
                <div class="ms-Persona-imageArea">
                  <i class="ms-Icon ms-Icon--AccountManagement clickableIcon" (click)="navigateTo('/home/usuarios')"></i>
                </div>
                <div class="ms-Persona-details">
                  <div class="ms-Persona-primaryText">Usuarios</div>
                  <div class="ms-Persona-secondaryText">
                    Cree o gestione un usuario
                  </div>
                </div>
              </div>
            </div>
            <ul class="ms-PersonaCard-actions">
              <li
                data-action-id="chat"
                class="ms-PersonaCard-action is-active"
                tabindex="1"
              >
                <i class="ms-Icon ms-Icon--AccountManagement"></i>
              </li>
              <li
                class="ms-PersonaCard-overflow"
                (click)="navigateTo('/home/usuarios')"
              >
                Ir a Usuarios
              </li>
              <li
                data-action-id="org"
                class="ms-PersonaCard-action ms-PersonaCard-orgChart"
                tabindex="5"
              >
                <i class="ms-Icon ms-Icon--Org"></i>
              </li>
            </ul>
          </div>
        </div>

        <!-- Card for Tareas -->
        <div class="card-item" *ngIf="hasRoutePermission('tareas')">
          <div class="ms-PersonaCard">
            <div class="ms-PersonaCard-persona">
              <div class="ms-Persona ms-Persona--lg">
                <div class="ms-Persona-imageArea">
                  <i class="ms-Icon ms-Icon--TaskManager clickableIcon" (click)="navigateTo('/home/tareas')"></i>
                </div>
                <div class="ms-Persona-details">
                  <div class="ms-Persona-primaryText">Tareas</div>
                  <div class="ms-Persona-secondaryText">
                    Cree o gestione una tarea
                  </div>
                </div>
              </div>
            </div>
            <ul class="ms-PersonaCard-actions">
              <li
                data-action-id="chat"
                class="ms-PersonaCard-action is-active"
                tabindex="1"
              >
                <i class="ms-Icon ms-Icon--TaskManager"></i>
              </li>
              <li
                class="ms-PersonaCard-overflow"
                (click)="navigateTo('/home/tareas')"
              >
                Ir a Tareas
              </li>
              <li
                data-action-id="org"
                class="ms-PersonaCard-action ms-PersonaCard-orgChart"
                tabindex="5"
              >
                <i class="ms-Icon ms-Icon--Org"></i>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Key Metrics Section -->
  <div class="metrics-section">
    <h2 class="section-title">Métricas Principales</h2>
    <div class="metrics-grid">
      <!-- Total Processes Card -->
      <div class="metric-card total-processes">
        <div class="metric-icon">
          <i class="ms-Icon ms-Icon--ProcessMetaTask"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{ formatNumber(dashboardData.TotalProcesses) }}</div>
          <div class="metric-label">Total Procesos</div>
          <div class="metric-trend positive">
            <i class="ms-Icon ms-Icon--TrendingUp"></i>
          </div>
        </div>
      </div>

      <!-- Active Users Card -->
      <div class="metric-card active-users">
        <div class="metric-icon">
          <i class="ms-Icon ms-Icon--People"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{ formatNumber(dashboardData.ActiveUsers) }}</div>
          <div class="metric-label">Usuarios Activos</div>
          <div class="metric-trend positive">
            <i class="ms-Icon ms-Icon--TrendingUp"></i>
          </div>
        </div>
      </div>

      <!-- Pending Tasks Card -->
      <div class="metric-card pending-tasks">
        <div class="metric-icon">
          <i class="ms-Icon ms-Icon--TaskManager"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{ formatNumber(dashboardData.PendingTasks) }}</div>
          <div class="metric-label">Tareas Pendientes</div>
          <div class="metric-progress">
            <div class="progress-bar">
              <div 
                class="progress-fill" 
                [style.width.%]="getProgressPercentage(dashboardData.PendingTasks, 50)"
              ></div>
            </div>
            <span class="progress-text">{{ getProgressPercentage(dashboardData.PendingTasks, 50) }}% de capacidad</span>
          </div>
        </div>
      </div>

      <!-- Average Execution Time Card -->
      <div class="metric-card execution-time">
        <div class="metric-icon">
          <i class="ms-Icon ms-Icon--DateTime"></i>
        </div>
        <div class="metric-content">
          <div class="metric-value">{{ dashboardData.AverageExecutionTime }}h</div>
          <div class="metric-label">Tiempo Promedio</div>
          <div class="metric-trend negative">
            <i class="ms-Icon ms-Icon--TrendingDown"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Charts Section -->
  <div class="charts-section">
    <h2 class="section-title">Análisis y Tendencias</h2>
    <div class="charts-grid">
      <!-- Timeline Chart -->
      <div class="chart-card">
        <apx-chart
          [series]="timelineChartOptions.series"
          [chart]="timelineChartOptions.chart"
          [xaxis]="timelineChartOptions.xaxis"
          [yaxis]="timelineChartOptions.yaxis"
          [stroke]="timelineChartOptions.stroke"
          [colors]="timelineChartOptions.colors"
          [title]="timelineChartOptions.title"
          [grid]="timelineChartOptions.grid"
          [dataLabels]="timelineChartOptions.dataLabels"
          [tooltip]="timelineChartOptions.tooltip"
        ></apx-chart>
      </div>

      <!-- Process Status Chart -->
      <div class="chart-card">
        <apx-chart
          [series]="processStatusChartOptions.series"
          [chart]="processStatusChartOptions.chart"
          [colors]="processStatusChartOptions.colors"
          [labels]="processStatusChartOptions.labels"
          [title]="processStatusChartOptions.title"
          [legend]="processStatusChartOptions.legend"
          [dataLabels]="processStatusChartOptions.dataLabels"
          [tooltip]="processStatusChartOptions.tooltip"
          [responsive]="processStatusChartOptions.responsive"
        ></apx-chart>
      </div>

      <!-- Users Activity Chart -->
      <div class="chart-card">
        <apx-chart
          [series]="usersActivityChartOptions.series"
          [chart]="usersActivityChartOptions.chart"
          [xaxis]="usersActivityChartOptions.xaxis"
          [yaxis]="usersActivityChartOptions.yaxis"
          [stroke]="usersActivityChartOptions.stroke"
          [colors]="usersActivityChartOptions.colors"
          [title]="usersActivityChartOptions.title"
          [grid]="usersActivityChartOptions.grid"
          [dataLabels]="usersActivityChartOptions.dataLabels"
          [fill]="usersActivityChartOptions.fill"
          [tooltip]="usersActivityChartOptions.tooltip"
        ></apx-chart>
      </div>
    </div>
  </div>

  <!-- Process Status Summary -->
  <div class="status-section">
    <h2 class="section-title">Estado Actual del Sistema</h2>
    <div class="status-grid">
      <div class="status-item completed">
        <div class="status-number">{{ dashboardData.CompletedProcesses }}</div>
        <div class="status-label">Procesos Completados</div>
        <div class="status-icon">
          <i class="ms-Icon ms-Icon--CompletedSolid"></i>
        </div>
      </div>

      <div class="status-item running">
        <div class="status-number">{{ dashboardData.ExecutionProcesses }}</div>
        <div class="status-label">Procesos en Ejecución</div>
        <div class="status-icon">
          <i class="ms-Icon ms-Icon--Processing"></i>
        </div>
      </div>

      <div class="status-item cancelled">
        <div class="status-number">{{ dashboardData.CancelledProcesses }}</div>
        <div class="status-label">Procesos Cancelados</div>
        <div class="status-icon">
          <i class="ms-Icon ms-Icon--Cancel"></i>
        </div>
      </div>

      <div class="status-item active-tasks">
        <div class="status-number">{{ dashboardData.ActiveTasks }}</div>
        <div class="status-label">Tareas Activas</div>
        <div class="status-icon">
          <i class="ms-Icon ms-Icon--TaskManager"></i>
        </div>
      </div>
    </div>
  </div>
</div>
